import { $ } from "@/plug/Axios";

export default {
  /**
   * 活动信息
   */
  activityInfo: {
    /*
     * 添加
     * bottomBackground 底部背景图 (string query )
     * bottomImage 底部图 (string query )
     * contactList 联系人名单 (string query )
     * endColor 主页面渐变色结束颜色 (string query )
     * headerBackground 主页面头部背景图 (string query )
     * id  (integer query )
     * name 活动名称 (string query )
     * startColor 主页面渐变色开始颜色 (string query )
     * venueButtonColor 场地按钮颜色 (string query )
     */
    post: (p, c) => $.post("/api/cms/activity/activityInfo", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/activity/activityInfo", p, c)
  },
  activityInfo_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/activity/activityInfo/details", p, c)
  },
  activityInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/activity/activityInfo/list", p, c)
  },
  activityInfo_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/cms/activity/activityInfo/listSimple", p, c)
  },

  /**
   * 活动头部操作
   */
  headerOperate: {
    /*
     * 添加
     * activityId 活动id (integer query )
     * buttonBackgroundColor 按钮背景颜色 (string query )
     * contentEndColor 内容块渐变色结束颜色 (string query )
     * contentSplitColor 内容分割线颜色 (string query )
     * contentStartColor 内容块渐变色开始颜色 (string query )
     * endColor 渐变色结束颜色 (string query )
     * headerBackground 头部背景图 (string query )
     * icon 图标 (string query )
     * id  (integer query )
     * name 按钮名称 (string query )
     * sort 排序 (integer query )
     * startColor 渐变色开始颜色 (string query )
     * type 类型：行程表、参加人员、链接、其他 (string query )
     * url 链接 (string query )
     */
    post: (p, c) => $.post("/api/cms/activity/headerOperate", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/activity/headerOperate", p, c)
  },
  headerOperate_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/activity/headerOperate/details", p, c)
  },
  headerOperate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/activity/headerOperate/list", p, c)
  },
  headerOperate_listByActivityId: {
    /*
     * 根据活动id获取列表
     * activityId 活动id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/activity/headerOperate/listByActivityId", p, c)
  },

  /**
   * 活动行程
   */
  hodometer: {
    /*
     * 添加
     * activityId 活动id (integer query )
     * content 内容（可回车换行） (string query )
     * id  (integer query )
     * sort 排序 (integer query )
     * time 时间 (string query )
     * title 标题 (string query )
     */
    post: (p, c) => $.post("/api/cms/activity/hodometer", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/activity/hodometer", p, c)
  },
  hodometer_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/activity/hodometer/list", p, c)
  },
  hodometer_listByActivityIdAndTitle: {
    /*
     * 根据活动id和标题获取列表
     * activityId 活动id (integer query required)
     * title 标题 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/activity/hodometer/listByActivityIdAndTitle", p, c)
  },
  hodometer_listTitleByActivityId: {
    /*
     * 根据活动id获取标题列表
     * activityId 活动id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/activity/hodometer/listTitleByActivityId", p, c)
  },

  /**
   * 活动参与人员
   */
  participant: {
    /*
     * 添加
     * activityId 活动id (integer query )
     * id  (integer query )
     * info 信息 (string query )
     * name 姓名 (string query )
     * sort 排序 (string query )
     */
    post: (p, c) => $.post("/api/cms/activity/participant", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/activity/participant", p, c)
  },
  participant_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/activity/participant/details", p, c)
  },
  participant_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/activity/participant/list", p, c)
  },
  participant_listByActivityId: {
    /*
     * 根据活动id获取列表
     * activityId 活动id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/activity/participant/listByActivityId", p, c)
  },

  /**
   * 活动场地
   */
  venue: {
    /*
     * 添加
     * activityId 活动id (integer query )
     * content 内容（可回车换行） (string query )
     * contentEndColor 内容块渐变色结束颜色 (string query )
     * contentStartColor 内容块渐变色开始颜色 (string query )
     * endColor 渐变色结束颜色 (string query )
     * headerBackground 头部背景 (string query )
     * headerImage 头部图片 (string query )
     * host 主持人 (string query )
     * hostEndColor 主持人块渐变色结束颜色 (string query )
     * hostInfo 主持人信息 (string query )
     * hostStartColor 主持人块渐变色开始颜色 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * sharing 分享嘉宾 (string query )
     * sharingInfo 分享嘉宾信息 (string query )
     * sort 排序 (integer query )
     * startColor 渐变色开始颜色 (string query )
     */
    post: (p, c) => $.post("/api/cms/activity/venue", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/activity/venue", p, c)
  },
  venue_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/activity/venue/details", p, c)
  },
  venue_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/activity/venue/list", p, c)
  },
  venue_listSimple: {
    /*
     * 简易列表
     * activityId 活动id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/activity/venue/listSimple", p, c)
  }
};
